import { Toast } from './Toast'
import type { ToastEntry } from './ToastProvider'
import './Toast.css'

interface ToastContainerProps {
  toasts: ToastEntry[]
  onDismiss: (id: string) => void
}

export function ToastContainer({ toasts, onDismiss }: ToastContainerProps) {
  return (
    <div className="toast-container" role="region" aria-label="Notifications" aria-live="polite">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  )
}
